"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useClickOutside = void 0;

var _react = require("react");

/**
 * Use click outside is a hook that will listen for clicks outside of a ref,
 * and when true, execute a callback.
 */
var useClickOutside = function useClickOutside(_ref) {
  var ref = _ref.ref,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? "click" : _ref$type,
      _ref$when = _ref.when,
      when = _ref$when === void 0 ? true : _ref$when,
      onClickOutside = _ref.onClickOutside;
  var savedHandler = (0, _react.useRef)(onClickOutside);
  (0, _react.useEffect)(function () {
    savedHandler.current = onClickOutside;
  }, [onClickOutside]);
  (0, _react.useEffect)(function () {
    var handleClick = function handleClick(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        savedHandler.current(event);
      }
    };

    if (when) {
      setTimeout(function () {
        document.addEventListener(type, handleClick);
      }, 0);
      return function () {
        document.removeEventListener(type, handleClick);
      };
    }
  }, [ref, type, when]);
};

exports.useClickOutside = useClickOutside;
//# sourceMappingURL=useClickOutside.js.map